import React from 'react'
import PropTypes from 'prop-types'
import './Alert.scss'

const Alert = ({ children, marginTop, marginBottom }) => {
  return (
    <div className="alert-border" style={{ marginTop, marginBottom }}>
      {children}
    </div>
  )
}
Alert.propTypes = {
  children: PropTypes.node,
  marginTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  marginBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

Alert.defaultProps = {
  children: null,
  marginTop: 0,
  marginBottom: 0,
}
export default Alert
